import { render, staticRenderFns } from "./ErrorCsv.vue?vue&type=template&id=60d5ebc2&scoped=true"
import script from "./ErrorCsv.vue?vue&type=script&lang=ts"
export * from "./ErrorCsv.vue?vue&type=script&lang=ts"
import style0 from "./ErrorCsv.vue?vue&type=style&index=0&id=60d5ebc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d5ebc2",
  null
  
)

export default component.exports